import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class OrderHistoryAuditReportData extends ReportData<OrderHistoryAuditReportData> {
    @field reportType: string = "SIMPLE";

    @collection() groupBy: string[] = ["none"];
    @collection() actionType: number[];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
}
